'use es6';

import { Record } from 'immutable';
import LegalConsentOptionsRecord from './LegalConsentOptionsRecord';
const LegalConsentRecord = Record({
  portalId: null,
  deckId: null,
  deckLegalConsentEnabled: null,
  consentFormId: null,
  legalConsentOptions: LegalConsentOptionsRecord()
}, 'LegalConsentRecord');

LegalConsentRecord.fromJS = ({
  portalId,
  deckId,
  deckLegalConsentEnabled,
  consentFormId,
  legalConsentOptions,
  communicationConsentSettings = [],
  domain,
  companyName,
  accountName,
  consentTextLang
}) => {
  let legalConsentOptionsRecord = null;

  if (deckLegalConsentEnabled) {
    legalConsentOptionsRecord = LegalConsentOptionsRecord.create({
      legalConsentOptions,
      communicationConsentSettings,
      domain,
      companyName,
      accountName,
      consentTextLang
    });
  }

  return LegalConsentRecord({
    portalId,
    deckId,
    deckLegalConsentEnabled,
    consentFormId,
    legalConsentOptions: legalConsentOptionsRecord
  });
};

export default LegalConsentRecord;